import substituteSymbols from "utils/substitute-symbols";

export function convertToSingleSymbolReels(grid: string[][]): string[][] {
    const flattenedReels: string[][] = [];

    grid.forEach((column) => column.forEach((symbol) => {
        flattenedReels.push([symbol]);
    }));

    return flattenedReels;
}

export function convertToReelsGrid(grid: string[][]) {
    const rows = 3;
    const columns = 5;
    const reels: string[][] = [];

    for (let i = 0; i < rows; i++) {
        for (let j = 0; j < columns; j++) {

            if (!reels[j]) {
                reels[j] = [];
            }

            const symbol = grid[i + j * rows][0];
            const unDimmedSymbol = symbol.split(`_${substituteSymbols.postfix}`)[0];

            reels[j].push(unDimmedSymbol);
        }
    }

    return reels;
}
